import { all } from "redux-saga/effects";

import Informativo from "./informativo/sagas";
import Manifestacoes from "./manifestacoes/sagas";
import PontosEssenciais from "./pontosessenciais/sagas";

export default all([Informativo, Manifestacoes, PontosEssenciais]);
